<footer class="adpBorder main-footer">
    <div class="container-dynamic d-flex">
        <p>1.38.0</p>
        <span class="m-auto"></span>
        Agricultural Digital Platform | 2021
    </div>
</footer>
